<div>
  <!-- SVG Clip Path Definition -->
  <svg viewBox="0 0 100 100" preserveAspectRatio="none">
    <clipPath id="curveRightClip" clipPathUnits="objectBoundingBox">
      <!-- From top-left to top-right with a curve inward on the right -->
      <path d="M0,0 L1,0 Q0.85,0.5 1,1 L0,1 Z" />
    </clipPath>
  </svg>

  <div class="authGridContainer authGridContainer--login authGridContainer--fullScreen">
    <a class="authGrid__logo" href="/" aria-label="Link to main page" tabindex="0">
      <img src="./assets/sbk1-logo.svg" alt="SBK1 - Monitoring" />
    </a>

    <div class="authGridColumn authGridColumn--callToActionParent image-half mario">
      <div class="createFreeAccount">
        <span class="createFreeAccount__text" style="font-size: 1.6em; line-height: 30px; display: none"
          >Effektives HACCP Maangement</span
        >
      </div>
    </div>

    <div class="authGridColumn authGridColumn--formParent">
      <div class="formContainer loginForm">
        <div class="example-small-box">
          <div *ngIf="isLoading" style="text-align: center; padding: 40px;">
            <p>Konto wird aktiviert...</p>
          </div>
          
          <div *ngIf="!isLoading && error && !isExpired">
            <h1 class="mb-0" style="font-size: 25px">SBK1 - Monitoring</h1>
            <h3 class="mb-3">Fehler</h3>
            <p class="mb-3">{{ error }}</p>
            <button mat-button mat-ripple class="btn-primary" (click)="router.navigate(['/login'])">
              Zur Anmeldung
            </button>
          </div>

          <div *ngIf="!isLoading && isExpired">
            <h1 class="mb-0" style="font-size: 25px">SBK1 - Monitoring</h1>
            <h3 class="mb-3">Aktivierungslink abgelaufen</h3>
            <p class="mb-3">{{ error }}</p>
            <p class="mb-4">Sie können einen neuen Aktivierungslink anfordern.</p>
            <button mat-button mat-ripple class="btn-primary" (click)="requestNewToken()">
              Neuen Aktivierungslink anfordern
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


